const DEFAULT_FORM_ID = 'default_form_id';
const DEFAULT_FORM_HOOK_ID = 'default_form_hook_id';

export {
  ALL_NAMESPACE_EVENTS,
  BUILD_EVENT,
  EXTRACT_EVENT_NAMESPACE,
  EXTRACT_CORE_NAMESPACE,
} from '@core/constants/observer';
export { CoreEvents, EEVents } from '@core/constants/events';
export { DEFAULT_FORM_ID, DEFAULT_FORM_HOOK_ID };
